var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "warehousing-detail" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            "label-position": "right",
            "show-message": false
          }
        },
        [
          _c("el-collapse", { attrs: { value: _vm.collapse } }, [
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "90%", "min-width": "1200px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.JobNumberInformation")))
                ]),
                _c(
                  "div",
                  {
                    staticClass: "form-row",
                    staticStyle: { display: "flex", "flex-direction": "row" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "right",
                          disabled: true
                        }
                      },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "section",
                            staticStyle: {
                              "flex-direction": "row",
                              width: "90%",
                              "min-width": "1200px"
                            },
                            attrs: { disabled: true }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  width: "64px"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("FbaJob.ValueAddedServices")
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.selectedLocalAddedService,
                                  callback: function($$v) {
                                    _vm.selectedLocalAddedService = $$v
                                  },
                                  expression: "selectedLocalAddedService"
                                }
                              },
                              [
                                _vm._l(_vm.localAddedService, function(item) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: item.code,
                                      staticStyle: {
                                        "margin-left": "8px",
                                        "margin-right": "8px"
                                      },
                                      attrs: { label: item.code }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.chineseName) + " "
                                      )
                                    ]
                                  )
                                }),
                                _c(
                                  "el-checkbox",
                                  {
                                    staticStyle: {
                                      "margin-left": "8px",
                                      "margin-right": "8px"
                                    },
                                    attrs: { no: "destinationPortService" },
                                    model: {
                                      value: _vm.form.destinationPortService,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "destinationPortService",
                                          $$v
                                        )
                                      },
                                      expression: "form.destinationPortService"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SeaExport.PortOfDestinationServices"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.BusinessNo"),
                                      prop: "jobNo"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "jobNo" },
                                      model: {
                                        value: _vm.form.jobNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "jobNo", $$v)
                                        },
                                        expression: "form.jobNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_Destination"
                                      ),
                                      prop: "warehouseCode"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: _vm.form.warehouseCode,
                                              placement: "bottom-end"
                                            }
                                          },
                                          [
                                            _c("el-cascader", {
                                              staticStyle: {
                                                width: "91px",
                                                "padding-right": "2px"
                                              },
                                              attrs: {
                                                no: "warehouseCode",
                                                options: _vm.destinations,
                                                filterable: "",
                                                clearable: true
                                              },
                                              on: {
                                                focus: function($event) {
                                                  return _vm.JobUtils.focusWarehouseCode(
                                                    _vm.form
                                                  )
                                                },
                                                blur: function($event) {
                                                  return _vm.JobUtils.blurWarehouseCode(
                                                    _vm.form
                                                  )
                                                },
                                                change: function(p) {
                                                  _vm.JobUtils.warehouseCodeHandler(
                                                    _vm.form,
                                                    p
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.warehouseCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "warehouseCode",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.warehouseCode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-checkbox",
                                          {
                                            attrs: { no: "remoteWarehouse" },
                                            model: {
                                              value: _vm.form.remoteWarehouse,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "remoteWarehouse",
                                                  $$v
                                                )
                                              },
                                              expression: "form.remoteWarehouse"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Warehouse.RemoteWarehouse"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "国外仓" } },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        no: "overseaWarehouseCode",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_OverseaWarehouse,
                                        filterable: "",
                                        "method-params": { ifFba: false },
                                        clearable: false,
                                        "tag-name": "countryChineseName",
                                        "tag-value": "warehouseCode",
                                        "default-value":
                                          _vm.form.overseaWarehouseCode
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.overseaWarehouseCode =
                                            p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ConsignationCompany"
                                      ),
                                      prop: "customerId"
                                    }
                                  },
                                  [
                                    _c("cargo-company-select", {
                                      attrs: {
                                        no: "customerId",
                                        "method-params": {
                                          customer: true,
                                          active: true
                                        },
                                        "default-value":
                                          _vm.form.customerId || ""
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.DestinationCountry"
                                      ),
                                      prop: "destinationCountry"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "destinationCountry" },
                                      model: {
                                        value: _vm.form.country,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "country", $$v)
                                        },
                                        expression: "form.country"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("FbaJob.ChargingMethod")
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.form.chargingMethod,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "chargingMethod",
                                              $$v
                                            )
                                          },
                                          expression: "form.chargingMethod"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "0" } },
                                          [_vm._v(_vm._s("KG"))]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "1" } },
                                          [_vm._v(_vm._s("CBM"))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.PoOriginalOrderNo"
                                      ),
                                      prop: "poNumber"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "poNumber" },
                                      model: {
                                        value: _vm.form.poNumber,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "poNumber", $$v)
                                        },
                                        expression: "form.poNumber"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.ZIP"),
                                      prop: "zip"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "zip" },
                                      model: {
                                        value: _vm.form.zipCode,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "zipCode", $$v)
                                        },
                                        expression: "form.zipCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "FbaChannel.bubbleCountingRatio"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.form.bubbleCountingRatio,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "bubbleCountingRatio",
                                            $$v
                                          )
                                        },
                                        expression: "form.bubbleCountingRatio"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.ServiceChannel"),
                                      prop: "serviceChannel"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "serviceChannel" },
                                      model: {
                                        value: _vm.form.serviceChannel,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "serviceChannel",
                                            $$v
                                          )
                                        },
                                        expression: "form.serviceChannel"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.DestinationDeliveryMethod"
                                      ),
                                      prop: "deliveryMethod"
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        no: "destinationDistribution",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES,
                                        filterable: "",
                                        clearable: false,
                                        "default-value":
                                          _vm.form.destinationDistribution
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.destinationDistribution =
                                            p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "分泡比例" } },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        "controls-position": "right",
                                        max: 100,
                                        min: 0,
                                        precision: 0
                                      },
                                      model: {
                                        value: _vm.form.bubbleSplittingRatio,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "bubbleSplittingRatio",
                                            $$v
                                          )
                                        },
                                        expression: "form.bubbleSplittingRatio"
                                      }
                                    }),
                                    _vm._v("% ")
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Pricing.TransportMode"),
                                      prop: "shippingType"
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        no: "shippingType",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .local_cache_FbaJobConstants$SHIPPING_TYPES,
                                        filterable: "",
                                        clearable: false,
                                        "default-value": _vm.form.shippingType
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.shippingType = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm.form.destinationDistribution &&
                                Number(_vm.form.destinationDistribution) === 1
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "Warehouse.CourierServicesCompany"
                                          ),
                                          prop: "courierServicesCompany"
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            no: "courierServicesCompany"
                                          },
                                          model: {
                                            value: _vm.form.expressCompany,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "expressCompany",
                                                $$v
                                              )
                                            },
                                            expression: "form.expressCompany"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "90%", "min-width": "1200px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.WarehouseInformation")))
                ]),
                _c(
                  "div",
                  {
                    staticClass: "form-row",
                    staticStyle: { display: "flex", "flex-direction": "row" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "110px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "required",
                                    attrs: {
                                      label: _vm.$t("Warehouse.WarehouseNo"),
                                      prop: "warehouseNo"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: true },
                                      on: {
                                        change: _vm.warehouseNoChargeHandler
                                      },
                                      model: {
                                        value: _vm.form.warehouseNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "warehouseNo", $$v)
                                        },
                                        expression: "form.warehouseNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width required",
                                    attrs: {
                                      label: _vm.$t("Warehouse.WarehouseName"),
                                      prop: "warehouse"
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "warehouse",
                                        disabled: !_vm.isEditing,
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_OverseaWarehouse,
                                        filterable: "",
                                        "method-params": { ifFba: false },
                                        clearable: false,
                                        "tag-name": "countryChineseName",
                                        "tag-value": "warehouseCode",
                                        "default-value": _vm.form.warehouse
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.warehouse = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("Warehouse.Warehouseman"),
                                      prop: "warehouseOp"
                                    }
                                  },
                                  [
                                    _c("cargo-user-select", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        "method-params": {
                                          officeId: _vm.form.opOffice,
                                          category: "role",
                                          shape: "warehouseOp"
                                        },
                                        "default-value":
                                          _vm.form.warehouseOp || "",
                                        disabled: !_vm.isEditing
                                      },
                                      on: {
                                        change: function(p) {
                                          _vm.form.warehouseOp = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.WarehouseLocation"
                                      ),
                                      prop: "location"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.form.location,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "location", $$v)
                                        },
                                        expression: "form.location"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "required",
                                    attrs: {
                                      label: _vm.$t("Warehouse.StorageDate"),
                                      prop: "warehouseInDate"
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        type: "datetime",
                                        disabled: true,
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm"
                                      },
                                      model: {
                                        value: _vm.form.warehouseInDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "warehouseInDate",
                                            $$v
                                          )
                                        },
                                        expression: "form.warehouseInDate"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("Warehouse.DeliveryDate"),
                                      prop: "warehouseOutDate"
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        type: "datetime",
                                        disabled: true,
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm"
                                      },
                                      model: {
                                        value: _vm.form.warehouseOutDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "warehouseOutDate",
                                            $$v
                                          )
                                        },
                                        expression: "form.warehouseOutDate"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "isPallet" } },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: { disabled: !_vm.isEditing },
                                        on: {
                                          change:
                                            _vm.daycareInformationChangeHandler
                                        },
                                        model: {
                                          value: _vm.form.pallet,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "pallet", $$v)
                                          },
                                          expression: "form.pallet"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Warehouse.DaycareInformation"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.PalletSum"),
                                      prop: "palletSum"
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        disabled: true,
                                        "controls-position": "right",
                                        max: 10,
                                        min: 0,
                                        precision: 0
                                      },
                                      model: {
                                        value: _vm.form.palletSum,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "palletSum", $$v)
                                        },
                                        expression: "form.palletSum"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.DeliveryCmp"),
                                      prop: "DeliveryCmp"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.form.deliveryCmp,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "deliveryCmp", $$v)
                                        },
                                        expression: "form.deliveryCmp"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.LicensePlate"),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.form.truckNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "truckNo", $$v)
                                        },
                                        expression: "form.truckNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.Driver"),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.form.driver,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "driver", $$v)
                                        },
                                        expression: "form.driver"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.DriverPhone"),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.form.driverTel,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "driverTel", $$v)
                                        },
                                        expression: "form.driverTel"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "isBroken" } },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: { disabled: !_vm.isEditing },
                                        on: {
                                          change: _vm.checkboxChangeHandler
                                        },
                                        model: {
                                          value: _vm.form.broken,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "broken", $$v)
                                          },
                                          expression: "form.broken"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Warehouse.IsNotComputationIsAffectedByDampness"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.ComputationIsAffectedByDampnessNum"
                                      ),
                                      prop: "brokenNum"
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        min: 0,
                                        max: 99999,
                                        "controls-position": "right",
                                        precision: 0,
                                        disabled: !(
                                          _vm.isEditing && _vm.form.broken
                                        )
                                      },
                                      model: {
                                        value: _vm.form.brokenQuantity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "brokenQuantity",
                                            $$v
                                          )
                                        },
                                        expression: "form.brokenQuantity"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.DescriptionOfGoods"
                                      ),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "custom-textarea",
                                      staticStyle: {
                                        width: "95%",
                                        height: "64px"
                                      },
                                      attrs: {
                                        type: "textarea",
                                        row: 3,
                                        disabled: !_vm.isEditing
                                      },
                                      model: {
                                        value: _vm.form.brokenDes,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "brokenDes", $$v)
                                        },
                                        expression: "form.brokenDes"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.HandlingOpinions"
                                      ),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "custom-textarea",
                                      staticStyle: {
                                        width: "95%",
                                        height: "64px"
                                      },
                                      attrs: {
                                        type: "textarea",
                                        row: 3,
                                        disabled: !_vm.isEditing
                                      },
                                      model: {
                                        value: _vm.form.comments,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "comments", $$v)
                                        },
                                        expression: "form.comments"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "receiveDc" } },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: { disabled: !_vm.isEditing },
                                        model: {
                                          value: _vm.form.receiveDc,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "receiveDc", $$v)
                                          },
                                          expression: "form.receiveDc"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Warehouse.ReceiveDc"))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "FbaJob.OperationStatusOfForeignWarehouse"
                                      ),
                                      prop: "outWarehouseStatus"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "95%" },
                                        attrs: {
                                          no: "outWarehouseStatus",
                                          placeholder: "",
                                          disabled: ""
                                        },
                                        model: {
                                          value: _vm.form.outWarehouseStatus,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "outWarehouseStatus",
                                              $$v
                                            )
                                          },
                                          expression: "form.outWarehouseStatus"
                                        }
                                      },
                                      _vm._l(
                                        _vm.FbaJobConstants
                                          .OVERSEA_WAREHOUSE_STATUS,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.chineseName,
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.FaceOrderPrintTime"
                                      ),
                                      prop: "faceOrderPrintTime"
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        type: "datetime",
                                        disabled: !_vm.isEditing,
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm"
                                      },
                                      model: {
                                        value: _vm.form.faceOrderPrintTime,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "faceOrderPrintTime",
                                            $$v
                                          )
                                        },
                                        expression: "form.faceOrderPrintTime"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("Warehouse.CourierNumber"),
                                      prop: "courierNumber"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.form.courierNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "courierNumber",
                                            $$v
                                          )
                                        },
                                        expression: "form.courierNumber"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.Remark"),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "custom-textarea",
                                      staticStyle: {
                                        width: "95%",
                                        height: "64px"
                                      },
                                      attrs: {
                                        type: "textarea",
                                        row: 3,
                                        disabled: !_vm.isEditing
                                      },
                                      model: {
                                        value: _vm.form.remarks,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "remarks", $$v)
                                        },
                                        expression: "form.remarks"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "90%", "min-width": "1200px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.CargoDetails")))
                ]),
                _c(
                  "div",
                  { staticClass: "form-row grid-list" },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "left",
                          disabled: !_vm.isEditing
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("cargo-ag-grid", {
                              ref: "goodsTableAct",
                              staticStyle: {
                                height: "200px",
                                "min-width": "1150px"
                              },
                              attrs: {
                                "config-module": "9300010",
                                "grid-options": _vm.detailList.goodGridOptions,
                                "column-defs": _vm.detailList.goodsColumn,
                                "row-data": _vm.form.warehouseInDetailList || []
                              },
                              on: {
                                gridReady: function(params) {
                                  _vm.detailList.gridApi = params.api
                                }
                              }
                            }),
                            _c("el-form-item", { staticClass: "auto-width" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "title-row",
                                  staticStyle: {
                                    display: "flex",
                                    "text-align": "left"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "80px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.Quantity"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "150px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.Weight2")) +
                                          " KGS"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "120px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.Cubage")) +
                                          " CBM"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "120px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.VolumetricWeight")
                                        ) + " KGS"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "150px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.ChargedWeight")
                                        ) + " M/T"
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: { label: _vm.$t("SeaExport.Actual") }
                              },
                              [
                                _c("el-input-number", {
                                  attrs: {
                                    disabled: true,
                                    "controls-position": "right",
                                    min: 0,
                                    max: 999999999,
                                    precision: 0
                                  },
                                  model: {
                                    value: _vm.form.quantitySum,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "quantitySum", $$v)
                                    },
                                    expression: "form.quantitySum"
                                  }
                                }),
                                _c("el-input-number", {
                                  attrs: {
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 2,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.weightSum,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "weightSum", $$v)
                                    },
                                    expression: "form.weightSum"
                                  }
                                }),
                                _c("el-input-number", {
                                  attrs: {
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 3,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.cubageSum,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "cubageSum", $$v)
                                    },
                                    expression: "form.cubageSum"
                                  }
                                }),
                                _c("el-input-number", {
                                  attrs: {
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 3,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.volumetricWeightAct,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "volumetricWeightAct",
                                        $$v
                                      )
                                    },
                                    expression: "form.volumetricWeightAct"
                                  }
                                }),
                                _c("el-input-number", {
                                  attrs: {
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 3,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.chargeWeightAct,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "chargeWeightAct", $$v)
                                    },
                                    expression: "form.chargeWeightAct"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: {
                                  label: _vm.$t("SeaExport.Consignation")
                                }
                              },
                              [
                                _c("el-input-number", {
                                  attrs: {
                                    disabled: true,
                                    "controls-position": "right",
                                    min: 0,
                                    max: 999999999,
                                    precision: 0
                                  },
                                  model: {
                                    value: _vm.form.quantityContract,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "quantityContract",
                                        $$v
                                      )
                                    },
                                    expression: "form.quantityContract"
                                  }
                                }),
                                _c("el-input-number", {
                                  attrs: {
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 2,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.weightContract,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "weightContract", $$v)
                                    },
                                    expression: "form.weightContract"
                                  }
                                }),
                                _c("el-input-number", {
                                  attrs: {
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 3,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.cubageContract,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "cubageContract", $$v)
                                    },
                                    expression: "form.cubageContract"
                                  }
                                }),
                                _c("el-input-number", {
                                  attrs: {
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 3,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.volumetricWeightContract,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "volumetricWeightContract",
                                        $$v
                                      )
                                    },
                                    expression: "form.volumetricWeightContract"
                                  }
                                }),
                                _c("el-input-number", {
                                  attrs: {
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 3,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.chargeWeightContract,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "chargeWeightContract",
                                        $$v
                                      )
                                    },
                                    expression: "form.chargeWeightContract"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "90%", "min-width": "1200px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.CargoPhotos")))
                ]),
                _c(
                  "div",
                  { staticClass: "form-row grid-list" },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "left",
                          disabled: !_vm.isEditing
                        }
                      },
                      [
                        _c(
                          "el-form",
                          { staticClass: "spacing" },
                          [
                            _c(
                              "el-upload",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  action:
                                    _vm.URL.warehouseIn
                                      .uploadFileForWarehouseIn +
                                    "?warehouseInUuid=" +
                                    _vm.warehouseInUuid,
                                  headers: {
                                    sessionId: _vm.$store.getters.token
                                  },
                                  "show-file-list": false,
                                  "on-success": _vm.uploadSuccess,
                                  "on-change": _vm.toChooseFile,
                                  disabled: !_vm.isEditing
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      disabled: !_vm.isEditing
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Warehouse.SelectFile"))
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  disabled: !_vm.isEditing
                                },
                                on: { click: _vm.delPhotoHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("Warehouse.DeleteFile")))]
                            )
                          ],
                          1
                        ),
                        _c("cargo-ag-grid", {
                          ref: "photosList",
                          staticStyle: {
                            height: "200px",
                            "min-width": "1150px"
                          },
                          attrs: {
                            "config-module": "9300013",
                            "grid-options": _vm.photoList.gridOptions,
                            "column-defs": _vm.photoList.photoColumn,
                            "row-data": _vm.form.businessDocumentVOList || []
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.photoList.gridApi = params.api
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "90%", "min-width": "1200px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.OperationRequirements")))
                ]),
                _c(
                  "div",
                  { staticClass: "form-row grid-list" },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "left",
                          disabled: !_vm.isEditing
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("cargo-ag-grid", {
                              ref: "opList",
                              staticStyle: {
                                height: "200px",
                                "min-width": "1150px"
                              },
                              attrs: {
                                "config-module": "9300004",
                                "grid-options": _vm.opList.options,
                                "column-defs": _vm.opList.opColumn,
                                "row-data":
                                  _vm.form.operationRequirementVOList || []
                              },
                              on: {
                                gridReady: function(params) {
                                  _vm.opList.gridApi = params.api
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm.fileTypeEditor.visible
        ? _c("mx-file-type-editor", {
            attrs: {
              visible: _vm.fileTypeEditor.visible,
              lob: _vm.fileTypeEditor.lob,
              "file-id": _vm.fileTypeEditor.fileId,
              "file-category": _vm.fileTypeEditor.fileCategory
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.fileTypeEditor, "visible", $event)
              },
              saveFileType: _vm.itemEditEndHandler
            }
          })
        : _vm._e(),
      _vm.jobNosWindow.visible
        ? _c("job-nos-window", {
            attrs: {
              visible: _vm.jobNosWindow.visible,
              "job-nos": _vm.jobNosWindow.jobs
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.jobNosWindow, "visible", $event)
              },
              selectJobNoHandler: _vm.selectJobNoHandler
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }